import {
  CreateAnnouncementModal,
  AnnouncementList,
  CreateAnnouncementButton,
} from '@exam-center/admin-announcements-list';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { Flex, Text, Box, Paper } from '@shared/components';
import { useDisclosure } from '@shared/hooks';
import { PermissionGuard } from '@shared/permissions';

export default function WebRegisterAnnouncementsListPage() {
  return (
    <PermissionGuard
      requiredPermission={[
        APP_PERMISSIONS.ADMIN_ANNOUNCEMENT_MANAGEMENT.WEB_REGISTER_ANNOUNCEMENT.VIEW,
      ]}
    >
      <WebRegisterAnnouncementsList />
    </PermissionGuard>
  );
}

function WebRegisterAnnouncementsList() {
  const [isCreateAnnouncementModalOpen, { open: openCreateAnnouncementModal, close: closeModal }] =
    useDisclosure(false);
  return (
    <>
      <Flex sx={(theme) => ({ p: theme.spacing(8, 6), justifyContent: 'space-between' })}>
        <Text variant='h1'>ประกาศข่าวสาร</Text>
        <CreateAnnouncementButton onClick={openCreateAnnouncementModal} />
      </Flex>
      <Box sx={(theme) => ({ p: theme.spacing(6) })}>
        <Paper sx={(theme) => ({ p: theme.spacing(6) })}>
          <AnnouncementList openCreateAnnouncementDialog={openCreateAnnouncementModal} />
        </Paper>
      </Box>
      <CreateAnnouncementModal open={isCreateAnnouncementModalOpen} onClose={closeModal} />
    </>
  );
}
